import React, { Fragment, useState, useEffect } from 'react';
import { TransitionGroup, CSSTransition } from 'components';
import { mount } from './mount';
import { get, range, shuffle } from 'lodash';
import * as css from 'styles/gallery/gallery.scss';

export const GalleryContainer = mount({ tagName: 'app-gallery', propsFromServer: true }, props => {
  const [ state, setState ] = useState({
    images: props.images.slice(0, 4),
    pool: props.images.slice(4),
    order: range(0, 4),
  });

  useEffect(() => {
    const index = state.order.shift();
    const newImage = state.pool.shift();
    const oldImage = state.images[index];
    state.pool.push(oldImage);
    state.order = shuffle(state.order);
    state.order.push(index);
    state.images.splice(index, 1, newImage);
    const timer = setTimeout(() => setState({...state}), 3000 + 2000*Math.random());
    return () => clearTimeout(timer);
  });

  return (
    <Fragment>
      <Gallery className={css.forMobile} images={props.images} />
      <Gallery className={css.forDesktop} images={state.images} />
    </Fragment>
  );
});

const Gallery = props => (
  <TransitionGroup className={props.className}>
    { props.images.map((image, index) =>
      <CSSTransition key={image.id} timeout={1000}>
        <div className={css.imageContainer + ' ' + css['imageContainer'+index]}>
          <img className={css.image} src={image.src} srcSet={image.srcset} />
        </div>
      </CSSTransition>
    ) }
  </TransitionGroup>
);

